/**
 * VibeCats — Hero Section Animations
 *
 * Gerencia as animações de entrada e scroll da seção Hero.
 * Inclui fade-in de textos, parallax da imagem e floating shapes.
 */

const HeroAnim = (($) => {
    'use strict';

    let heroTL = null;

    /**
     * Animação de entrada do Hero (ao carregar a página).
     * @returns {gsap.core.Timeline}
     */
    function createEntryAnimation() {
        const tl = $.timeline({
            defaults: { ease: 'power3.out' },
        });

        // Tagline
        const tagline = document.querySelector('[data-anim="hero-tagline"]');
        if (tagline) {
            tl.from(tagline, {
                y: 30,
                opacity: 0,
                duration: 0.8,
            }, 0);
        }

        // Title lines
        const titleLines = document.querySelectorAll('[data-anim="hero-title"] .hero__title-line');
        if (titleLines.length) {
            tl.from(titleLines, {
                y: 80,
                opacity: 0,
                duration: 1,
                stagger: 0.15,
            }, 0.2);
        }

        // Description
        const desc = document.querySelector('[data-anim="hero-desc"]');
        if (desc) {
            tl.from(desc, {
                y: 40,
                opacity: 0,
                duration: 0.9,
            }, 0.6);
        }

        // Actions (buttons)
        const actions = document.querySelector('[data-anim="hero-actions"]');
        if (actions) {
            tl.from(actions.children, {
                y: 30,
                opacity: 0,
                duration: 0.7,
                stagger: 0.15,
            }, 0.9);
        }

        // Visual / image
        const visual = document.querySelector('[data-anim="hero-visual"]');
        if (visual) {
            tl.from(visual, {
                scale: 0.8,
                opacity: 0,
                rotation: 5,
                duration: 1.2,
                ease: 'power2.out',
            }, 0.3);
        }

        // Scroll indicator
        const scrollIndicator = document.querySelector('.hero__scroll-indicator');
        if (scrollIndicator) {
            tl.from(scrollIndicator, {
                y: 20,
                opacity: 0,
                duration: 0.8,
            }, 1.4);
        }

        return tl;
    }

    /**
     * Cria os efeitos de parallax do Hero vinculados ao scroll.
     */
    function createScrollEffects() {
        // Parallax suave na imagem do Hero
        const heroImage = document.querySelector('.hero__image');
        if (heroImage) {
            $.timeline({
                scrollTrigger: {
                    trigger: '.hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1.5,
                },
            })
                .to(heroImage, {
                    y: 80,
                    scale: 1.05,
                    ease: 'none',
                }, 0);
        }

        // Fade-out do conteúdo do Hero ao scrollar
        const heroContent = document.querySelector('.hero__content');
        if (heroContent) {
            $.timeline({
                scrollTrigger: {
                    trigger: '.hero',
                    start: 'top top',
                    end: 'center top',
                    scrub: 1,
                },
            })
                .to(heroContent, {
                    //opacity: 0,
                    y: -50,
                    ease: 'none',
                }, 0);
        }

        // Parallax nas shapes flutuantes
        document.querySelectorAll('.hero__shape').forEach((shape, i) => {
            $.to(shape, {
                y: 30 + (i * 20),
                scrollTrigger: {
                    trigger: '.hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1,
                },
                ease: 'none',
            });
        });
    }

    /**
     * Inicializa todas as animações do Hero.
     */
    function init() {
        if (Utils.prefersReducedMotion()) {
            // Se reduzir movimento, apenas mostra tudo sem animar
            document.querySelectorAll('[data-anim]').forEach((el) => {
                el.style.opacity = '1';
                el.style.transform = 'none';
            });
            return;
        }

        // Animação de entrada
        heroTL = createEntryAnimation();
        heroTL.play();

        // Efeitos de scroll
        createScrollEffects();
    }

    /**
     * Mata as animações do Hero.
     */
    function destroy() {
        if (heroTL) {
            heroTL.kill();
            heroTL = null;
        }
    }

    return {
        init,
        destroy,
    };
})(gsap);
